<template>
  <div class="query" id="query">
    <form action="/">
      <van-search
        v-model="wd"
        :class="[
          !isBFDApp && !checkXcx ? '' : 'search-input'
        ]"
        background="#fff"
        :placeholder="shadedWords || TLang('请输入搜索关键词', 'quick')"
        :autofocus="autoFocus"
        show-action
        @search="onSearch"
        @input="onInput"
        @focus="onFocus"
        @blur="$emit('onblur')"
      >
        <div slot="action" @click="onSearch">{{ TLang("搜索", "quick") }}</div>
        <img slot="left-icon" src="../assets/imgs/icon_search.png" class="search-icon" />
      </van-search>
      <!-- <van-icon
        class="query-back"
        name="arrow-left"
        @click="onBack"
        v-if="!isBFDApp && !checkXcx"
      ></van-icon> -->
      <img class="back-icon" @click="onBack" src="../assets/imgs/icon_blackBack.png" alt="" v-if="!isBFDApp && !checkXcx">
    </form>
  </div>
</template>

<script>
import { getFilterParam, gioClickHandle } from "../utils";
import { TLang } from "../utils/lang";
import { getSearchUrl, getSensitiveUrl } from "@/assets/js/api";
import { mapState } from "vuex";
import { Toast } from "vant";
import { BFD_checkApp } from "@/utils/bfdApp.js";
import { getCatchAddress } from 'dflocationsdk';
export default {
  props: {
    keyword: {
      type: String,
      default: "",
    },
    city: {
      type: Number,
      default: null,
    },
    autoFocus: {
      type: Boolean,
      default: true,
    },
    shadedWords: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      wd: this.keyword,
      cityId: this.city,
    };
  },
  computed: {
    ...mapState({
      loginInfo: (state) => state.loginInfo,
      allQuery: (state) => state.allQuery,
    }),
  },
  mounted() {
    setTimeout(() => {
      let paramsCommon = {
        df_pagename: '搜索结果页',
        df_modulename: '',
        df_elementname: '',
        df_pageUrl: window.location.href
      };
      gioClickHandle('DF_enterEvent', Object.assign({}, paramsCommon), false);
      gioClickHandle('DF_exposureEvent', Object.assign({}, paramsCommon), false);
    }, 500)
    document.addEventListener("touchmove", this.onTouchMove);
  },
  beforeDestroy() {
    document.removeEventListener("touchmove", this.onTouchMove);
  },
  methods: {
    goGio(isCiUrl) {
      // 触发 埋点
      gioClickHandle("DF_elementClick", {
        df_searchKeyword: this.wd,
        // df_ifSearchResult: hasRes,
        df_ifLogin: this.loginInfo.loginFlag ? "是" : "否",
        df_cityid: this.cityId,
        df_modulename: "搜索关键词",
        df_elementname: "搜索关键词",
        df_pageType: isCiUrl ? "词链" : "",
        df_filter: getFilterParam(this.allQuery),
      });
    },
    async onSearch() {
      const sensRes = await getSensitiveUrl({
        keyword: this.wd || this.shadedWords,
        platform: BFD_checkApp() ? 3 : 1
      });
      let isSensitive = false;
      if (sensRes && sensRes.data && sensRes.data.body) {
        isSensitive = true;
      }
      const res = await getSearchUrl({
        keyword: this.wd  || this.shadedWords,
        platform: BFD_checkApp() ? 3 : 1
      });
      if (res && res.data && res.data.body && res.data.body.linkUrl) {
        this.goGio(true);
        // 要记录进最近搜索
        if (!isSensitive) {
          const data = { key: this.wd  || this.shadedWords };
          this.$store.dispatch("commitInitData", data);
        }
        // 埋点添加
        window.df_sdk_common.location.href = res.data.body.linkUrl;
        this.wd = "";
      } else {
        this.goGio(false);
        const add = getCatchAddress()
        let _currentCity=this.cityId
        if(add){
          const _cityInfo = JSON.parse(add)
          if(_cityInfo&&_cityInfo.cityId){
            _currentCity = _cityInfo.cityId
          }
        }
        const data = {
          key: this.wd  || this.shadedWords,
          city: _currentCity,
          isCardRights: 0,
          cardChoose: 0,
          isSensitive: isSensitive
        };
        this.$store.commit("setbusinessFrontTagId", '')
        this.$emit("handlerSearch", data, false);
      }
    },
    onInput(value) {
      const limit = 60
      if (value && value.length > limit) {
        Toast(TLang('您输入的搜词过长', 'search'), {className: 'toast-zindex'});
        this.wd = value.slice(0, limit);
        return
      }
      const locationInfo = JSON.parse(localStorage.getItem("systemLoaction"));
        const add = getCatchAddress()
        let _currentCity=this.cityId
        if(add){
          const _cityInfo = JSON.parse(add)
          if(_cityInfo&&_cityInfo.cityId){
            _currentCity = _cityInfo.cityId
          }
        }
      let data = {
        key: this.wd,
        city: _currentCity,
      };
      if (locationInfo) {
        data.longitude = locationInfo.location.lng;
        data.latitude = locationInfo.location.lat;
      }
      this.$emit("handlerInput", data);
    },
    onFocus() {
      const locationInfo = JSON.parse(localStorage.getItem("systemLoaction"));const add = getCatchAddress()
        let _currentCity=this.cityId
        if(add){
          const _cityInfo = JSON.parse(add)
          if(_cityInfo&&_cityInfo.cityId){
            _currentCity = _cityInfo.cityId
          }
        }
      let data = {
        key: this.wd,
        city: _currentCity,
      };
      if (locationInfo) {
        data.longitude = locationInfo.location.lng;
        data.latitude = locationInfo.location.lat;
      }
      this.$emit("handlerFoucs", data);
    },
    onBack() {
      const RETURN_URL = localStorage.getItem("RETURN_URL");

      if (RETURN_URL) {
        window.df_sdk_common.location.href = RETURN_URL;
      } else {
        window.history.back();
      }
    },
    onTouchMove(ev) {
      if (ev.target.tagName.toLowerCase() !== "input") {
        document
          .getElementById("query")
          .querySelector("input")
          .blur();
      }
    },
  },
  watch: {
    keyword(val) {
      this.wd = val;
    },
    city(val) {
      this.cityId = val;
    },
  },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.van-search {
  padding-top: 6px * @375;
  padding-bottom: 6px * @375;
  padding-left: 54px * @375;
  &__content {
    border-radius: 16px * @375;
    background: #f7f7f7;
    height: 32px * @375;
  }
  &__action {
    color: #3FA6FF;
    font-size: 14px * @375;
    padding-left: 15px * @375;
    padding-right: 15px * @375;
    font-weight: 400;
    line-height: 32px * @375;
    &:active {
      background-color: transparent;
    }
  }
}
.search-input {
  padding-left: 15px * @375;
}

.van-cell {
  font-size: 12px;
  line-height: 19px;
}

.query {
  position: relative;
  .search-icon {
    display: block;
    width: 12px * @375;
    height: 12px * @375;
    margin: 4px * @375 auto 0;
  }
  &-back {
    position: absolute;
    left: 0;
    top: 14px;
    color: #fff;
    font-size: 16px;
    padding-left: 10px;
    padding-right: 10px;
  }
}
.back-icon {
  position: absolute;
  display: block;
  width: 24px * @375;
  height: 24px * @375;
  top: 10px * @375;
  left: 15px * @375;
}
</style>

<style>
.toast-zindex {
  z-index: 9998;
}
</style>
